var map = {
	"./active-users.png": 6825,
	"./active.png": 9332,
	"./arrow-active.png": 3413,
	"./arrow-enabled.png": 4250,
	"./arrow-inactive.png": 7054,
	"./arrow-left.png": 6142,
	"./arrow-right.png": 5133,
	"./audit-logs.png": 5946,
	"./avatar.png": 3328,
	"./blacklist.png": 5169,
	"./calendar.png": 3442,
	"./dashboard.png": 3768,
	"./decision-models.png": 2910,
	"./dropdown.png": 4119,
	"./empty-star.png": 4303,
	"./fees-and-charges.png": 6391,
	"./fees-and-pricing.png": 1540,
	"./filter-button.png": 4108,
	"./full-star.png": 2916,
	"./guarantors.png": 8321,
	"./karma.png": 9843,
	"./keydropdown.png": 9628,
	"./loan-products.png": 8627,
	"./loan-requests.png": 9060,
	"./loans.png": 3396,
	"./log-out.png": 6396,
	"./logo.png": 6338,
	"./logout.png": 3408,
	"./notification.png": 8131,
	"./organization.png": 3650,
	"./pagination-down-button.png": 8693,
	"./preferences.png": 8705,
	"./reports.png": 8545,
	"./savings-products.png": 8579,
	"./savings.png": 7905,
	"./search.png": 3105,
	"./service-account.png": 8788,
	"./services.png": 1773,
	"./settlements.png": 8175,
	"./smiling-woman.png": 2404,
	"./switch-organization.png": 5629,
	"./systems-messages.png": 4901,
	"./transactions.png": 1469,
	"./users-.png": 285,
	"./users-with-loans.png": 9844,
	"./users-with-savings.png": 2411,
	"./users.png": 4980,
	"./vertical-menu.png": 6351,
	"./watch.png": 3637,
	"./whitelists.png": 3638
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7872;